import React from 'react';
import { Button, Icon, Modal } from 'lmc-ui-library';
import styles from './../../CaseDetailsPage.module.scss';
import { useDispatch } from 'react-redux';
import { fixSentDataErrors } from '../store/useCases';
import { Error } from '../store';

interface Props {
  errors: Error[];
}

const SendToPepperErrors = (props: Props) => {
  const { errors } = props;
  const dispatch = useDispatch();

  const onFixErrorClick = () => {
    dispatch(fixSentDataErrors());
  };

  return (
    <>
      <Modal.Header title="Error!" mode="error" className={styles.modalHeader} />
      <Modal.Content>
        <div className={styles.contentText}>
          {errors.map((error) => {
            return (
              <div className={styles.errorItem}>
                <Icon type="warning" color="#FA5245" />
                <div className={styles.errorText}>{error}</div>
              </div>
            );
          })}
        </div>
      </Modal.Content>
      <Modal.Footer style={{ display: 'grid' }}>
        <Button mode="ghost" borderVariant="rectangle" className={styles.actionButton} onClick={onFixErrorClick}>
          Fix errors
        </Button>
      </Modal.Footer>
    </>
  );
};

export default SendToPepperErrors;
